import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import Picker from "emoji-picker-react";

/**
 * A dialog that displays an emoji picker.
 * @param {boolean} open - Whether the dialog is open
 * @param {function} onClose - Callback when dialog is closed
 * @param {function} onEmojiSelect - Callback when an emoji is selected (receives unified emoji code)
 * @param {string} selectedEmoji - Currently selected emoji (unified code)
 */
const EmojiPickerDialog = ({ open, onClose, onEmojiSelect }) => {
  const handleEmojiClick = (emojiObject) => {
    onEmojiSelect(emojiObject.unified);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" sx={{ zIndex: 1302 }}>
      <DialogContent sx={{ p: 0 }}>
        <Picker onEmojiClick={handleEmojiClick} height={350} width={320} />
      </DialogContent>
    </Dialog>
  );
};

export default EmojiPickerDialog;
